// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ee4f6ac9","667":"17cbf3fc","977":"5a6f2f10"}[chunkId] + ".chunk.js";
};